import { useEffect, useState } from 'react'

export const usePageTitle = (): string => {
  const [pageTitle, setPageTitle] = useState('')

  useEffect(() => {
    const titleElement = document.querySelector('title')
    const fullTitle = titleElement?.textContent || ''

    if (fullTitle.endsWith('| Ameriprise Financial')) {
      const cleanedTitle = fullTitle.substring(0, fullTitle.lastIndexOf('|')).trim()
      setPageTitle(cleanedTitle)
    } else {
      setPageTitle(fullTitle)
    }
  }, [])

  return pageTitle
}
